import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f569624a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f569624a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f569624a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f569624a')) {
      api.createRecord('f569624a', component.options)
    } else {
      api.reload('f569624a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f569624a&scoped=true&", function () {
      api.rerender('f569624a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PZ0nrcyyN7Nc/JS/comp/PopupBox.vue"
export default component.exports